import React, { useEffect, useState } from "react";
import DragDropChart from "../DragAndDrop";
import { json, useParams } from "react-router-dom";
import axios from "axios";
import { IoCaretDown, IoCaretUp } from "react-icons/io5";
import { TbArrowNarrowLeftDashed } from "react-icons/tb";
import { MdSubdirectoryArrowLeft } from "react-icons/md";
import { useGlobalContext } from "../../../context/context";
import Cookies from "js-cookie";
import { AiOutlineDelete, AiOutlineFileDone } from "react-icons/ai";
import { FiEdit } from "react-icons/fi";
import "../org.css";
const LawMinerPlusSectionAndChapters = ({ ID }) => {
  const {
    isTokenExpired,
    NewfetchRefreshToken,
    setCookieToken,
    CookieToken,
    GetListSubject,
    Parents,
    subjectsType,
    GetSubjectTypeEnum,
    fetchDataLwSubjectTree,
    LwTData,
    setLawTData,
    LwTDataID,setLawTDataID
    
   
  } = useGlobalContext();
 console.log("LwTDataID",LwTDataID)
  const [openChild, setOpenChild] = useState(true);
  const [openChildLv2, setOpenChildLv2] = useState(true);
  const [openChildLv3, setOpenChildLv3] = useState(true);
  const [recordID, setRecordID] = useState(0);
  const [recordID2, setRecordID2] = useState(0);
  const [recordID3, setRecordID3] = useState(0);
  const horizontal = false;
  const collapsable = true;
  const expandAll = true;
  const [tdata, setData] = useState([]);
  const params = useParams();
  const [loading, setLoading] = useState(false);
  const [ShowInput, setShowInput] = useState(false);
  const [IDshowInput, setIDShowInput] = useState(0);
  const [DeleteId, setDeleteID] = useState(0);
  const [selectNode, setSelectNode] = useState({});
  // const CookieToken=JSON.parse(Cookies.get('token'))
  const hasCookie = Cookies.get("token");
  const [newInfo, setNewInfo] = useState({
    title: "",
    parentID: null,
    definition: "",
    ordering: 0,
    subjectType: 0,
    keywords: "",
    isPublic: true,
  });
  // console.log(CookieToken)
  useEffect(() => {
    if (hasCookie !== null || hasCookie !== undefined) {
      const token = hasCookie !== undefined && JSON.parse(Cookies.get("token"));
      setCookieToken(token);
      setLoading(true);
      if (isTokenExpired(token.accessToken)) {
        NewfetchRefreshToken();
      } else {
        fetchDataLwSubjectTree(LwTDataID==null ?ID:LwTDataID);
      }
    }
  }, []);
  // console.log(CookieToken.accessToken)
  // const fetchDataLwSubjectTree = async () => {
  //   try {
  //     let config = {
  //       method: "post",
  //       url: `${process.env.REACT_APP_BASE_URL_PROFILE}/v1/UserLwSubject/SubjectsTree`,
  //       headers: {
  //         Authorization: `Bearer ${CookieToken.accessToken}`,
  //         "Content-Type": "application/json",
  //       },
  //       data: JSON.stringify({
  //         tabvib: true,
  //         addroot: true,
  //         parentId: ID,
  //       }),
  //     };
  //     await axios.request(config).then((res) => {
  //       const list = res.data;
  //       setData(list.data);
  //       setLoading(false)
  //     });
  //   } catch (error) {
  //     console.log("errorfetchDataSubjectsTree", error);
  //   }
  // };

  const DeleteTreeNode = async (id) => {
    // console.log(ID)
    try {
      if (isTokenExpired(CookieToken.accessToken)) {
        NewfetchRefreshToken();
      } else {
        let config = {
          method: "post",
          url: `${process.env.REACT_APP_BASE_URL_PROFILE}/v1/UserLwSubject/DeleteUserLwSubject?id=${id}`,
          headers: {
            Authorization: `Bearer ${CookieToken.accessToken}`,
            "Content-Type": "application/json",
          },
        };
        await axios.request(config).then((res) => {
          // const list = res.data;
          console.log(res);
          if (res.status == 200) {
            alert("اطلاعات با موفقیت حذف شد ");
            setShowInput(false);
            // window.location.reload()
            fetchDataLwSubjectTree(ID);
          }
          // console.log(list.data)
          // setData(list.data);
        });
      }
    } catch (error) {
      console.log("errorfetchDataSubjectsTree", error);
    }
  };
  const GetNode = (id) => {
    console.log("id",id)
    setSelectNode({});
    try {
      if (isTokenExpired(CookieToken.accessToken)) {
        NewfetchRefreshToken();
      } else {
        let config = {
          method: "post",
          url: `${process.env.REACT_APP_BASE_URL_PROFILE}/v1/UserLwSubject/GetUserLwSubject?id=${id}`,
          headers: {
            Authorization: `Bearer ${CookieToken.accessToken}`,
            "Content-Type": "application/json",
          },
        };
        axios.request(config).then((res) => {
          const list = res.data;
        // console.log("kkkk",list)
          setSelectNode(list.data);
          setShowInput(!ShowInput);
          GetListSubject();
        });
      }
    } catch (error) {
      console.log("errorfetchDataSubjectsTree", error);
    }
  };
  const EditTreeNode = () => {
    console.log("newInfo",newInfo); 
  
    try {
      if (isTokenExpired(CookieToken.accessToken)) {
        NewfetchRefreshToken();
      } else {
        let config = {
          method: "post",
          url: `${process.env.REACT_APP_BASE_URL_PROFILE}/v1/UserLwSubject/UpdateUserLwSubjectForTree`,
          headers: {
            Authorization: `Bearer ${CookieToken.accessToken}`,
            "Content-Type": "application/json",
          },
          // data: JSON.stringify({
          //   title: newInfo.title !== "" ? newInfo.title : selectNode.title,
          //   parentID:
          //     newInfo.parentID == 0 ? selectNode.parentID : newInfo.parentID,
          //   definition:
          //     newInfo.definition !== ""
          //       ? newInfo.definition
          //       : selectNode.definition,
          //   ordering:
          //     newInfo.ordering !== 0 ? newInfo.ordering : selectNode.ordering,
          //   subjectType:
          //     newInfo.subjectType !== 0
          //       ? newInfo.subjectType
          //       : selectNode.subjectType,
          //   keywords:
          //     newInfo.keywords !== "" ? newInfo.keywords : selectNode.keywords,
          //   isPublic: selectNode.isPublic,
          //   id: selectNode.id,
          // }),
          data:JSON.stringify({
            id:  selectNode.id,
            title: newInfo.title !== "" ? newInfo.title : selectNode.title,
            parentID: newInfo.parentID ===null ? selectNode.parentID : newInfo.parentID,
            lwSubjectId: Number(ID)
          })
        };
        axios.request(config).then((res) => {
          console.log(res);
          if (res.status == 200) {
            alert("اطلاعات با موفقیت ویرایش شد ");
            setShowInput(false);
            fetchDataLwSubjectTree(ID);
          }
        });
      }
    } catch (error) {
      console.log("errorfetchDataSubjectsTree", error);
    }
  };
  const handleOpen = (id) => {
    setOpenChild(!openChild);
    setRecordID(id);
  };
  const handleOpenLv2 = (id) => {
    setOpenChildLv2(!openChildLv2);
    setRecordID2(id);
  };
  const handleOpenLv3 = (id) => {
    setOpenChildLv3(!openChildLv3);
    setRecordID3(id);
  };
  // console.log("Tdata",LwTData);
  console.log("seleNode",selectNode)
  // console.log(ShowInput);
  return (
    <>
      <div>
        {
          LwTData.length!==0 &&
          LwTData.map((i) => {
            return (
              <>
                <div className="w-full flex flex-col px-5">
                  <div
                    className={`w-full bg-[#526E48] text-white  p-2  border-2  ${
                      i.children.length > 0 && !ShowInput
                        ? "hover:border-[#526E48] hover:bg-white hover:text-[#789461]    cursor-pointer"
                        : ""
                    }`}
                  >
                    {/* {i.name} {i.title} */}
                    {i.children.length > 0 ? (
                      <>
                        <div className="flex w-full items-center justify-between">
                          {selectNode.id == i.id && ShowInput ? (
                            <div className=" rounded-md bg-white gap-3 py-2 items-center text-black w-[95%] pl-6 pr-3">
                              {/* hrlloo */}
                              <div className="w-full grid grid-cols-2 gap-3">
                                <div className="w-full flex items-center">
                                  <label className="w-[25%]  text-[14px] font-IranSans">
                                    عنوان:
                                  </label>
                                  <input
                                    onChange={(e) =>
                                      setNewInfo((prev) => ({
                                        ...prev,
                                        title: e.target.value,
                                      }))
                                    }
                                    className="w-full border-2 border-gray-400 p-1 rounded-md focus:outline-none"
                                    defaultValue={selectNode.title}
                                  />
                                </div>
                                <div className="w-full flex items-center ">
                                  <label className="w-[25%]  text-[14px] font-IranSans">
                                    سرشاخه:
                                  </label>
                                  <select
                                    onChange={(e) =>
                                      setNewInfo((prev) => ({
                                        ...prev,
                                        parentID: Number(e.target.value),
                                      }))
                                    }
                                    className="border-2 text-[14px] font-IranSans rounded-md mr-3 w-full p-1 focus:outline-none"
                                  >
                                    {/* <option></option> */}
                                    {Parents.length > 0 ? (
                                      Parents.map((item) => {
                                        return (
                                          <>
                                            {item.id == selectNode.parentID ? (
                                              <option selected value={item.id}>
                                                {item.title}
                                              </option>
                                            ) : (
                                              <option value={item.id}>
                                                {item.title}
                                              </option>
                                            )}
                                          </>
                                        );
                                      })
                                    ) : (
                                      <></>
                                    )}
                                  </select>
                                </div>
                              </div>
                              <div className="w-full mt-2  ltr">
                                <button
                                  className="TreeBtn font-IranSans"
                                  onClick={EditTreeNode}
                                >
                                  {/* <svg class="css-i6dzq1" stroke-linejoin="round" stroke-linecap="round" fill="none" stroke-width="2" stroke="#FFFFFF" height="15" width="15" viewBox="0 0 24 24">
        <path d="M17 3a2.828 2.828 0 1 1 4 4L7.5 20.5 2 22l1.5-5.5L17 3z"></path>
    </svg> */}
                                  ثبت
                                </button>
                              </div>
                              {/* <button className="flex items-center" onClick={EditTreeNode}>
                            <AiOutlineFileDone className="text-[18px]" />
                            ثبت تغییرات 
                          </button> */}
                            </div>
                          ) : (
                            <div
                              onClick={() => handleOpen(i.id)}
                              className="flex items-center  text-[18px] "
                            >
                              {i.name + "--" + i.title}
                              {openChild ? (
                                <IoCaretUp className="ml-2" />
                              ) : (
                                <IoCaretDown className="ml-2" />
                              )}
                            </div>
                          )}
                          <div className="flex gap-2 ">
                            <button
                              onClick={() => {
                                GetNode(i.id);
                                // setShowInput(!ShowInput), setIDShowInput(i.id);
                              }}
                            >
                              <FiEdit className="text-[16px] " />
                            </button>

                            <button onClick={() => DeleteTreeNode(i.id)}>
                              <AiOutlineDelete className="text-[16px] " />
                            </button>
                          </div>
                        </div>
                      </>
                    ) : (
                      <div className="flex w-full items-center justify-between">
                        {selectNode.id === i.id && ShowInput ? (
                          <div className="rounded-md bg-white gap-3 py-2 items-center text-black w-[95%] pl-6 pr-3">
                            <div className="grid grid-cols-2 gap-3 w-full">
                              <div className="w-full flex items-center">
                                <label className="w-[25%]  text-[14px] font-IranSans">
                                  عنوان:
                                </label>
                                <input
                                  onChange={(e) =>
                                    setNewInfo((prev) => ({
                                      ...prev,
                                      title: e.target.value,
                                    }))
                                  }
                                  className="w-full border-2 border-gray-400 p-1 rounded-md focus:outline-none"
                                  defaultValue={selectNode.title}
                                />
                              </div>
                              <div className="w-full flex items-center ">
                                <label className="w-[25%]  text-[14px] font-IranSans">
                                  سرشاخه:
                                </label>
                                <select
                                  onChange={(e) =>
                                    setNewInfo((prev) => ({
                                      ...prev,
                                      parentID: Number(e.target.value),
                                    }))
                                  }
                                  className="border-2 text-[14px] font-IranSans rounded-md mr-3 w-full p-1 focus:outline-none"
                                >
                                  <option></option>
                                  {Parents.length > 0 ? (
                                    Parents.map((item) => {
                                      return (
                                        <>
                                          {item.id == selectNode.parentID ? (
                                            <option selected value={item.id}>
                                              {item.title}
                                            </option>
                                          ) : (
                                            <option value={item.id}>
                                              {item.title}
                                            </option>
                                          )}
                                        </>
                                      );
                                    })
                                  ) : (
                                    <></>
                                  )}
                                </select>
                              </div>
                            </div>
                            <div className="w-full mt-2  ltr">
                              <button
                                className="TreeBtn font-IranSans"
                                onClick={EditTreeNode}
                              >
                                {/* <svg class="css-i6dzq1" stroke-linejoin="round" stroke-linecap="round" fill="none" stroke-width="2" stroke="#FFFFFF" height="15" width="15" viewBox="0 0 24 24">
        <path d="M17 3a2.828 2.828 0 1 1 4 4L7.5 20.5 2 22l1.5-5.5L17 3z"></path>
    </svg> */}
                                ثبت
                              </button>
                            </div>
                          </div>
                        ) : (
                          <div className="flex items-center   text-[18px]">
                            {i.name + "--" + i.title}
                          </div>
                        )}
                        <div className="flex gap-2">
                          <button
                            onClick={() => {
                              // console.log("idOnclick",i.id)
                              // setShowInput(!ShowInput),
                              GetNode(i.id);
                            }}
                          >
                            <FiEdit className="text-[16px]" />
                          </button>

                          <button onClick={() => DeleteTreeNode(i.id)}>
                            <AiOutlineDelete className="text-[16px]" />
                          </button>
                        </div>
                      </div>
                    )}
                  </div>
                  {i.children.length > 0 && openChild ? (
                    i.children.map((j) => {
                      return (
                        <>
                          <div
                            className={`w-full ${
                              openChild
                                ? "h-full duration-500 tansition-all"
                                : "h-0"
                            }`}
                          >
                            {j.children.length > 0 ? (
                              <>
                                <div
                                  className={`flex items-center pr-8  py-3 	border-b-2  text-[#16423C] justify-between  bg-[#C1CFA1] ${
                                    j.children.length > 0 && !ShowInput
                                      ? "hover:bg-white hover:border-[#C1CFA1] hover:border-2 hover: cursor-pointer"
                                      : ""
                                  }    `}
                                >
                                  {selectNode.id === j.id && ShowInput ? (
                                    <div className="rounded-md bg-white gap-3 py-2 items-center text-black w-[95%] pl-6 pr-3">
                                      <div className="grid grid-cols-2 gap-3 w-full">
                                        <div className="w-full flex items-center">
                                          <label className="w-[25%]  text-[14px] font-IranSans">
                                            عنوان:
                                          </label>
                                          <input
                                            onChange={(e) =>
                                              setNewInfo((prev) => ({
                                                ...prev,
                                                title: e.target.value,
                                              }))
                                            }
                                            className="w-full border-2 border-gray-400 p-1 rounded-md focus:outline-none"
                                            defaultValue={selectNode.title}
                                          />
                                        </div>
                                        <div className="w-full flex items-center ">
                                          <label className="w-[25%]  text-[14px] font-IranSans">
                                            سرشاخه:
                                          </label>
                                          <select
                                            onChange={(e) =>
                                              setNewInfo((prev) => ({
                                                ...prev,
                                                parentID: Number(
                                                  e.target.value
                                                ),
                                              }))
                                            }
                                            className="border-2 text-[14px] font-IranSans rounded-md mr-3 w-full p-1 focus:outline-none"
                                          >
                                            <option></option>
                                            {Parents.length > 0 ? (
                                              Parents.map((item) => {
                                                return (
                                                  <>
                                                    {item.id ==
                                                    selectNode.parentID ? (
                                                      <option
                                                        selected
                                                        value={item.id}
                                                      >
                                                        {item.title}
                                                      </option>
                                                    ) : (
                                                      <option value={item.id}>
                                                        {item.title}
                                                      </option>
                                                    )}
                                                  </>
                                                );
                                              })
                                            ) : (
                                              <></>
                                            )}
                                          </select>
                                        </div>
                                      </div>
                                      <div className="w-full mt-2  ltr">
                                        <button
                                          className="TreeBtn font-IranSans"
                                          onClick={EditTreeNode}
                                        >
                                          {/* <svg class="css-i6dzq1" stroke-linejoin="round" stroke-linecap="round" fill="none" stroke-width="2" stroke="#FFFFFF" height="15" width="15" viewBox="0 0 24 24">
                 <path d="M17 3a2.828 2.828 0 1 1 4 4L7.5 20.5 2 22l1.5-5.5L17 3z"></path>
             </svg> */}
                                          ثبت
                                        </button>
                                      </div>
                                    </div>
                                  ) : (
                                    <div
                                      onClick={() => handleOpenLv2(j.id)}
                                      className="flex items-center text-[16px]"
                                    >
                                      <MdSubdirectoryArrowLeft className="text-xl text-[#526E48]" />
                                      {j.name + "--" + j.title}
                                      {openChildLv2 ? (
                                        <IoCaretUp className="ml-2" />
                                      ) : (
                                        <IoCaretDown className="ml-2" />
                                      )}
                                    </div>
                                  )}
                                  <div className="flex gap-2 px-2">
                                    <button onClick={() => GetNode(j.id)}>
                                      <FiEdit className="text-[16px]" />
                                    </button>

                                    <button
                                      onClick={() => DeleteTreeNode(j.id)}
                                    >
                                      <AiOutlineDelete className="text-[16px]" />
                                    </button>
                                  </div>
                                </div>
                              </>
                            ) : (
                              <>
                                <div className="border-b-2 flex  items-center justify-between border-white bg-[#C1CFA1] text-[#16423C]  pr-8  py-3">
                                  {selectNode.id === j.id && ShowInput ? (
                                    <div className="rounded-md bg-white gap-3 py-2 items-center text-black w-[95%] pl-6 pr-3">
                                      <div className="grid grid-cols-2 gap-3 w-full">
                                        <div className="w-full flex items-center">
                                          <label className="w-[25%]  text-[14px] font-IranSans">
                                            عنوان:
                                          </label>
                                          <input
                                            onChange={(e) =>
                                              setNewInfo((prev) => ({
                                                ...prev,
                                                title: e.target.value,
                                              }))
                                            }
                                            className="w-full border-2 border-gray-400 p-1 rounded-md focus:outline-none"
                                            defaultValue={selectNode.title}
                                          />
                                        </div>
                                        <div className="w-full flex items-center ">
                                          <label className="w-[25%]  text-[14px] font-IranSans">
                                            سرشاخه:
                                          </label>
                                          <select
                                            onChange={(e) =>
                                              setNewInfo((prev) => ({
                                                ...prev,
                                                parentID: Number(
                                                  e.target.value
                                                ),
                                              }))
                                            }
                                            className="border-2 text-[14px] font-IranSans rounded-md mr-3 w-full p-1 focus:outline-none"
                                          >
                                            <option></option>
                                            {Parents.length > 0 ? (
                                              Parents.map((item) => {
                                                return (
                                                  <>
                                                    {item.id ==
                                                    selectNode.parentID ? (
                                                      <option
                                                        selected
                                                        value={item.id}
                                                      >
                                                        {item.title}
                                                      </option>
                                                    ) : (
                                                      <option value={item.id}>
                                                        {item.title}
                                                      </option>
                                                    )}
                                                  </>
                                                );
                                              })
                                            ) : (
                                              <></>
                                            )}
                                          </select>
                                        </div>
                                      </div>
                                      <div className="w-full mt-2  ltr">
                                        <button
                                          className="TreeBtn font-IranSans"
                                          onClick={EditTreeNode}
                                        >
                                          ثبت
                                        </button>
                                      </div>
                                    </div>
                                  ) : (
                                    <div className="flex items-center  text-[16px]">
                                      <MdSubdirectoryArrowLeft className="text-xl text-[#526E48]" />
                                      {j.name + "--" + j.title}
                                    </div>
                                  )}
                                  <div className="flex gap-2 px-2">
                                    <button onClick={() => GetNode(j.id)}>
                                      <FiEdit className="text-[16px]" />
                                    </button>

                                    <button
                                      onClick={() => DeleteTreeNode(j.id)}
                                    >
                                      <AiOutlineDelete className="text-[16px]" />
                                    </button>
                                  </div>
                                </div>
                              </>
                            )}
                          </div>
                          {j.children.length > 0 && openChildLv2 ? (
                            <>
                              {j.children.map((k) => {
                                return (
                                  <>
                                    <div
                                      className={
                                        k.children.length <= 0
                                          ? "w-full flex  items-center pr-12 text-[14px] border-b-2 border-dashed py-2 "
                                          : "w-full flex bg-[#D6EFD8]  items-center pr-12  border-b-2 border-dashed py-2 cursor-pointer hover:border-4 hover:border-[#D6EFD8] hover:bg-white"
                                      }
                                    >
                                      {k.children.lenght > 0 ? (
                                        <>
                                          <div className="w-full flex items-center justify-between">
                                            {selectNode.id === k.id &&
                                            ShowInput ? (
                                              <div className="rounded-md bg-white gap-3 py-2 items-center text-black w-[95%] pl-6 pr-3">
                                                <div className="grid grid-cols-2 gap-3 w-full">
                                                  <div className="w-full flex items-center">
                                                    <label className="w-[25%]  text-[14px] font-IranSans">
                                                      عنوان:
                                                    </label>
                                                    <input
                                                      onChange={(e) =>
                                                        setNewInfo((prev) => ({
                                                          ...prev,
                                                          title: e.target.value,
                                                        }))
                                                      }
                                                      className="w-full border-2 border-gray-400 p-1 rounded-md focus:outline-none"
                                                      defaultValue={
                                                        selectNode.title
                                                      }
                                                    />
                                                  </div>
                                                  <div className="w-full flex items-center ">
                                                    <label className="w-[25%]  text-[14px] font-IranSans">
                                                      سرشاخه:
                                                    </label>
                                                    <select
                                                      onChange={(e) =>
                                                        setNewInfo((prev) => ({
                                                          ...prev,
                                                          parentID: Number(
                                                            e.target.value
                                                          ),
                                                        }))
                                                      }
                                                      className="border-2 text-[14px] font-IranSans rounded-md mr-3 w-full p-1 focus:outline-none"
                                                    >
                                                      <option></option>
                                                      {Parents.length > 0 ? (
                                                        Parents.map((item) => {
                                                          return (
                                                            <>
                                                              {item.id ==
                                                              selectNode.parentID ? (
                                                                <option
                                                                  selected
                                                                  value={
                                                                    item.id
                                                                  }
                                                                >
                                                                  {item.title}
                                                                </option>
                                                              ) : (
                                                                <option
                                                                  value={
                                                                    item.id
                                                                  }
                                                                >
                                                                  {item.title}
                                                                </option>
                                                              )}
                                                            </>
                                                          );
                                                        })
                                                      ) : (
                                                        <></>
                                                      )}
                                                    </select>
                                                  </div>
                                                </div>
                                                <div className="w-full mt-2  ltr">
                                                  <button
                                                    className="TreeBtn font-IranSans"
                                                    onClick={EditTreeNode}
                                                  >
                                                    ثبت
                                                  </button>
                                                </div>
                                              </div>
                                            ) : (
                                              <div
                                                // onClick={() => handleOpenLv3(k.id)}
                                                className="flex items-center pr-8 text-[14px] py-3 border-b-2  hover:bg-white hover:border-[#D6EFD8]  bg-[#D6EFD8] hover:border-2 cursor-pointer "
                                              >
                                                <MdSubdirectoryArrowLeft className="text-xl text-[#526E48]" />
                                                {k.name + "--" + k.title}
                                                {openChildLv3 ? (
                                                  <IoCaretUp className="ml-2" />
                                                ) : (
                                                  <IoCaretDown className="ml-2" />
                                                )}
                                              </div>
                                            )}
                                            <div className="flex gap-2 px-2">
                                              <button
                                                onClick={() => {
                                                  // setShowInput(!ShowInput),
                                                  GetNode(k.id);
                                                }}
                                              >
                                                <FiEdit className="text-[16px]" />
                                              </button>

                                              <button
                                                onClick={() =>
                                                  DeleteTreeNode(k.id)
                                                }
                                              >
                                                <AiOutlineDelete className="text-[16px]" />
                                              </button>
                                            </div>
                                          </div>
                                        </>
                                      ) : (
                                        <>
                                          <div className="flex w-full items-center justify-between">
                                            {selectNode.id === k.id &&
                                            ShowInput ? (
                                              <div className="rounded-md bg-white gap-3 py-2 items-center text-black w-[95%] pl-6 pr-3">
                                                <div className="grid grid-cols-2 gap-3 w-full">
                                                  <div className="w-full flex items-center">
                                                    <label className="w-[25%]  text-[14px] font-IranSans">
                                                      عنوان:
                                                    </label>
                                                    <input
                                                      onChange={(e) =>
                                                        setNewInfo((prev) => ({
                                                          ...prev,
                                                          title: e.target.value,
                                                        }))
                                                      }
                                                      className="w-full border-2 border-gray-400 p-1 rounded-md focus:outline-none"
                                                      defaultValue={
                                                        selectNode.title
                                                      }
                                                    />
                                                  </div>
                                                  <div className="w-full flex items-center ">
                                                    <label className="w-[25%]  text-[14px] font-IranSans">
                                                      سرشاخه:
                                                    </label>
                                                    <select
                                                      onChange={(e) =>
                                                        setNewInfo((prev) => ({
                                                          ...prev,
                                                          parentID: Number(
                                                            e.target.value
                                                          ),
                                                        }))
                                                      }
                                                      className="border-2 text-[14px] font-IranSans rounded-md mr-3 w-full p-1 focus:outline-none"
                                                    >
                                                      <option></option>
                                                      {Parents.length > 0 ? (
                                                        Parents.map((item) => {
                                                          return (
                                                            <>
                                                              {item.id ==
                                                              selectNode.parentID ? (
                                                                <option
                                                                  selected
                                                                  value={
                                                                    item.id
                                                                  }
                                                                >
                                                                  {item.title}
                                                                </option>
                                                              ) : (
                                                                <option
                                                                  value={
                                                                    item.id
                                                                  }
                                                                >
                                                                  {item.title}
                                                                </option>
                                                              )}
                                                            </>
                                                          );
                                                        })
                                                      ) : (
                                                        <></>
                                                      )}
                                                    </select>
                                                  </div>
                                                </div>
                                                <div className="w-full mt-2  ltr">
                                                  <button
                                                    className="TreeBtn font-IranSans"
                                                    onClick={EditTreeNode}
                                                  >
                                                    ثبت
                                                  </button>
                                                </div>
                                              </div>
                                            ) : (
                                              <div className="flex items-center text-[14px]">
                                                <MdSubdirectoryArrowLeft className="text-xl text-[#C1CFA1]" />
                                                {k.name + "--" + k.title}
                                              </div>
                                            )}
                                            <div className="flex gap-2 px-2">
                                              <button
                                                onClick={() => {
                                                  // setShowInput(!ShowInput),
                                                  GetNode(k.id);
                                                }}
                                              >
                                                <FiEdit className="text-[16px]" />
                                              </button>

                                              <button
                                                onClick={() =>
                                                  DeleteTreeNode(k.id)
                                                }
                                              >
                                                <AiOutlineDelete className="text-[16px]" />
                                              </button>
                                            </div>
                                          </div>
                                        </>
                                      )}
                                    </div>
                                    {k.children.length > 0 ? (
                                      <>
                                        {k.children.map((l) => {
                                          return (
                                            <>
                                              <div className="w-full flex items-center justify-between py-2 border-b-2 border-dashed  px-20">
                                                {selectNode.id === l.id &&
                                                ShowInput ? (
                                                  <div className="rounded-md bg-white gap-3 py-2 items-center text-black w-[95%] pl-6 pr-3">
                                                    <div className="grid grid-cols-2 gap-3 w-full">
                                                      <div className="w-full flex items-center">
                                                        <label className="w-[25%]  text-[14px] font-IranSans">
                                                          عنوان:
                                                        </label>
                                                        <input
                                                          onChange={(e) =>
                                                            setNewInfo(
                                                              (prev) => ({
                                                                ...prev,
                                                                title:
                                                                  e.target
                                                                    .value,
                                                              })
                                                            )
                                                          }
                                                          className="w-full border-2 border-gray-400 p-1 rounded-md focus:outline-none"
                                                          defaultValue={
                                                            selectNode.title
                                                          }
                                                        />
                                                      </div>
                                                      <div className="w-full flex items-center ">
                                                        <label className="w-[25%]  text-[14px] font-IranSans">
                                                          سرشاخه:
                                                        </label>
                                                        <select
                                                          onChange={(e) =>
                                                            setNewInfo(
                                                              (prev) => ({
                                                                ...prev,
                                                                parentID:
                                                                  Number(
                                                                    e.target
                                                                      .value
                                                                  ),
                                                              })
                                                            )
                                                          }
                                                          className="border-2 text-[14px] font-IranSans rounded-md mr-3 w-full p-1 focus:outline-none"
                                                        >
                                                          <option></option>
                                                          {Parents.length >
                                                          0 ? (
                                                            Parents.map(
                                                              (item) => {
                                                                return (
                                                                  <>
                                                                    {item.id ==
                                                                    selectNode.parentID ? (
                                                                      <option
                                                                        selected
                                                                        value={
                                                                          item.id
                                                                        }
                                                                      >
                                                                        {
                                                                          item.title
                                                                        }
                                                                      </option>
                                                                    ) : (
                                                                      <option
                                                                        value={
                                                                          item.id
                                                                        }
                                                                      >
                                                                        {
                                                                          item.title
                                                                        }
                                                                      </option>
                                                                    )}
                                                                  </>
                                                                );
                                                              }
                                                            )
                                                          ) : (
                                                            <></>
                                                          )}
                                                        </select>
                                                      </div>
                                                    </div>
                                                    <div className="w-full mt-2  ltr">
                                                      <button
                                                        className="TreeBtn font-IranSans"
                                                        onClick={EditTreeNode}
                                                      >
                                                        {/* <svg class="css-i6dzq1" stroke-linejoin="round" stroke-linecap="round" fill="none" stroke-width="2" stroke="#FFFFFF" height="15" width="15" viewBox="0 0 24 24">
                              <path d="M17 3a2.828 2.828 0 1 1 4 4L7.5 20.5 2 22l1.5-5.5L17 3z"></path>
                          </svg> */}
                                                        ثبت
                                                      </button>
                                                    </div>
                                                  </div>
                                                ) : (
                                                  <div className="flex items-center text-[12px]">
                                                    <MdSubdirectoryArrowLeft className="text-xl text-[#D6EFD8]" />

                                                    {l.name + "--" + l.title}
                                                  </div>
                                                )}
                                                <div className="flex gap-2 px-2">
                                                  <button
                                                    onClick={() => {
                                                      // setShowInput(!ShowInput),
                                                      GetNode(l.id);
                                                    }}
                                                  >
                                                    <FiEdit className="text-[16px]" />
                                                  </button>

                                                  <button
                                                    onClick={() =>
                                                      DeleteTreeNode(l.id)
                                                    }
                                                  >
                                                    <AiOutlineDelete className="text-[16px]" />
                                                  </button>
                                                </div>
                                              </div>
                                            </>
                                          );
                                        })}
                                      </>
                                    ) : (
                                      <></>
                                    )}
                                  </>
                                );
                              })}
                            </>
                          ) : (
                            <></>
                          )}
                        </>
                      );
                    })
                  ) : (
                    <></>
                  )}
                </div>
              </>
            );
          })
        }
      </div>
    </>
  );
};

export default LawMinerPlusSectionAndChapters;
